import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { useUser } from '../../context/UserContext';
import Button from '../UI/Button';
import Select from '../UI/Select';

const RUSSIA_TIMEZONES = [
  { value: 'Europe/Kaliningrad', label: 'Калининград (UTC+2)' },
  { value: 'Europe/Moscow', label: 'Москва (UTC+3)' },
  { value: 'Europe/Samara', label: 'Самара (UTC+4)' },
  { value: 'Asia/Yekaterinburg', label: 'Екатеринбург (UTC+5)' },
  { value: 'Asia/Omsk', label: 'Омск (UTC+6)' },
  { value: 'Asia/Novosibirsk', label: 'Новосибирск (UTC+7)' },
  { value: 'Asia/Irkutsk', label: 'Иркутск (UTC+8)' },
  { value: 'Asia/Yakutsk', label: 'Якутск (UTC+9)' },
  { value: 'Asia/Vladivostok', label: 'Владивосток (UTC+10)' },
  { value: 'Asia/Magadan', label: 'Магадан (UTC+11)' },
  { value: 'Asia/Kamchatka', label: 'Петропавловск-Камчатский (UTC+12)' }
];

const TimezoneSettings = () => {
  const [timezone, setTimezone] = useState('Europe/Moscow');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { logout } = useUser();

  useEffect(() => {
    const fetchTimezone = async () => {
      try {
        setLoading(true);
        const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/settings/timezone`, {}, logout);
        const data = await response.json();
        setTimezone(data.timezone);
      } catch (err) {
        setError('Ошибка при получении настроек часового пояса');
        console.error('Ошибка:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTimezone();
  }, [logout]);

  const handleSave = async () => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);
      
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}/settings/timezone`,
        {
          method: 'POST',
          body: JSON.stringify({ timezone }),
          headers: {
            'Content-Type': 'application/json'
          }
        },
        logout
      );

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      } else {
        const errData = await response.json();
        setError(errData.message || 'Ошибка при обновлении часового пояса');
      }
    } catch (err) {
      setError('Ошибка при обновлении часового пояса');
      console.error('Ошибка:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#252526] p-6 rounded-lg border border-[#3E3E42] shadow-md">
      <h2 className="text-[#CCCCCC] text-xl mb-4 font-semibold">Настройки часового пояса</h2>
      <div className="mb-6">
        <label className="block text-[#CCCCCC] mb-2">Выберите часовой пояс:</label>
        <Select
          value={timezone}
          onChange={(e) => setTimezone(e.target.value)}
          options={RUSSIA_TIMEZONES}
          placeholder="Выберите часовой пояс"
          className="bg-[#2D2D30] text-[#CCCCCC] border-[#3E3E42]"
        />
      </div>
      
      {error && (
        <div className="mb-4 p-3 bg-red-900/30 border border-red-800 text-red-200 rounded">
          {error}
        </div>
      )}
      
      {success && (
        <div className="mb-4 p-3 bg-green-900/30 border border-green-800 text-green-200 rounded">
          Часовой пояс успешно обновлен
        </div>
      )}
      
      <Button 
        onClick={handleSave} 
        disabled={loading}
        className="w-full"
      >
        {loading ? 'Сохранение...' : 'Сохранить'}
      </Button>
    </div>
  );
};

export default TimezoneSettings; 